// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'
import { clearUserSession } from '../services/token'

const config = useJwt.jwtConfig

const initialUser = () => {
  try {
    const item = window.localStorage.getItem('userData')

    if (!item || item === 'undefined') return {}

    return JSON.parse(item)
  } catch (error) {
    console.error('Erro ao fazer parse do userData:', error)
    return {}
  }
}

export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    userData: initialUser()
  },
  reducers: {
    handleLogin: (state, action) => {
      state.userData = action.payload
      state[config.storageTokenKeyName] = action.payload[config.storageTokenKeyName]
      localStorage.setItem('userData', JSON.stringify(action.payload))
      localStorage.setItem(config.storageTokenKeyName, action.payload.accessToken)
      try {
        const jwtPayload = JSON.parse(atob(action.payload.accessToken.split('.')[1]))
        localStorage.setItem('sessionTokenexpiration', new Date(jwtPayload.exp * 1000).toISOString())
      } catch {
        localStorage.setItem('sessionTokenexpiration', '')
      }
    },
    handleLogout: state => {
      state.userData = {}
      state[config.storageTokenKeyName] = null
      clearUserSession()

      window.location.href = '/'
    }
  }
})

export const { handleLogin, handleLogout } = authSlice.actions

export default authSlice.reducer
